export default {"src":"/_next/static/media/native-plants.ef18da41.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};